/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Features_Progress_WeekInputs */

const en_features_progress_week = /** @type {(inputs: Features_Progress_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`W${i?.n}`)
};

const pl_features_progress_week = /** @type {(inputs: Features_Progress_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`T${i?.n}`)
};

/**
* | output |
* | --- |
* | "W{n}" |
*
* @param {Features_Progress_WeekInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_week = /** @type {((inputs: Features_Progress_WeekInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_WeekInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_week(inputs)
	return en_features_progress_week(inputs)
});